module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 7
// module chunks = 0